import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GridModule } from '@progress/kendo-angular-grid';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import {PrettyJsonModule} from 'angular2-prettyjson';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';

import{ modalComponent} from '../../../common/component/modal/modal.component';

@NgModule({
  imports: [
    CommonModule
    ,GridModule
    ,DateInputsModule
    ,PrettyJsonModule
    ,DialogModule
    ,DropDownsModule
  ],
  declarations: [modalComponent],
  exports: [modalComponent],
  schemas:[ CUSTOM_ELEMENTS_SCHEMA ]
})
export class ModalModule { }
